<app-banner [heading]="'OUR CLUBS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="events3" class="events3">
      <div class="container" data-aos="fade-up">
        <!--<h2><b>22/10/2021</b></h2>-->
		<h3>IT Club </h3>
		<div class="row">
	<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/comp1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/comp2.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/comp3.jpg" alt="best school in kurukshetra">
            </div>
			</div>
</div>
		<h3> Sports Club </h3>
		<div class="row">


            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/s1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/s2.jpg" alt="best school in kurukshetra">
            </div>
			</div>
			<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/s3.jpg" alt="best school in kurukshetra">
            </div>
			</div>
       
		  </div>
		  <h3> HomeScience Club </h3>
		<div class="row">

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/h4.jpg" alt="best school in kurukshetra">
            </div>
			</div>
			<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/h5.jpg" alt="best school in kurukshetra">
            </div>
			</div>
			<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/h1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/h2.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/h3.jpg" alt="best school in kurukshetra">
            </div>
			</div>
         
          
		</div>
		<h3>Albert Einstein Club </h3>
		<div class="row">
	<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci6.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci7.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci8.jpg" alt="best school in kurukshetra">
            </div>
			</div>
	<div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci4.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci5.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci2.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/sci3.jpg" alt="best school in kurukshetra">
            </div>
			</div>
            
				  
        </div>
		<h3>Art Club </h3>
		<div class="row">

         
            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/art1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/art2.jpg" alt="best school in kurukshetra">
            </div>
		</div>
		</div>
		<h3>Music Club </h3>
		<div class="row">

         
            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/music1.jpg" alt="best school in kurukshetra">
            </div>
			</div>

            <div class="col-md-4 d-flex align-items-stretch">
			<div class="card">
              <img src="assets/img/clubpic/music2.jpg" alt="best school in kurukshetra">
            </div>
			</div>		
          

				  
        </div>
      </div>
	</section><!-- End About Section -->
	
	
 

	
	
    
    
  </main>